<script lang="ts">
export let data: unknown;

// ソースコード中に script の閉じタグ文字列をそのまま書くと、Svelteコンパイラが
// このコンポーネント自身の script ブロックの終端と誤認するため分割して組み立てる
const SCRIPT_CLOSE_TAG = `</${"script>"}`;

// 閉じタグや HTML コメントによるタグ脱出を防ぐため `<` を Unicode エスケープする
$: json = JSON.stringify(data).replace(/</g, "\\u003c");
$: scriptTag = `<script type="application/ld+json">${json}${SCRIPT_CLOSE_TAG}`;
</script>

<svelte:head>
  {@html scriptTag}
</svelte:head>
